import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from '@/router'
import { registerPlugins } from '@/plugins'
import { vCan } from '@/directives/vCan'
import { vReveal } from '@/directives/vReveal'
import { usePlatformStore } from '@/stores/platform.store'

import '@/assets/styles/main.css'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)

registerPlugins(app)

app.directive('can', vCan)
app.directive('reveal', vReveal)

// Resuelve el contexto de tenant/plataforma (por hostname) ANTES de montar el
// router, para que guards y layouts conozcan el `mode` desde la primera ruta.
async function bootstrap() {
  try {
    await usePlatformStore(pinia).fetchContext()
  } catch {
    // fetchContext ya degrada a 'tenant' ante errores; nunca bloquea el arranque.
  }
  app.use(router)
  app.mount('#app')
}

void bootstrap()
